import Repository from "../Repository";

const resource = "/product/lower-limb-orthosis";

export default {
  async get(lower_limb_uuid) {
    return Repository.get(`${resource}/${lower_limb_uuid}`);
  },

  async createLowerLimb(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
